import VueI18n from "vue-i18n";
import globalVariables from "@/utils/globalVariables";
import Vue from "vue";
window.missingTrans = {
    'lt': {},
    'en': {}
};

const i18nBuilder = (options = {}) => {
    const i18n = new VueI18n({
        locale: options.locale || "en",
        fallbackLocale: options.fallbackLocale || "en",
        messages: options.messages || {
            en: {},
            lt: {},
        },
        silentTranslationWarn: options.silentTranslationWarn || true,
        pluralizationRules: {
            lt: function (choice) {
                if (choice === 0) {
                    return 0;
                }

                if (choice === 1 || choice % 10 === 1) return 1;

                return 2;
            },
        },
        // missing: (locale, key) => {
        //     // const localeTranslations = require(`~@/lang/${locale}.json`);
        //     const spaLocaleTranslations = require(`@/utils/service/Translations/locales/${locale}.json`);
        //
        //     // i18n.setLocaleMessage(locale, {[key]: spaLocaleTranslations[key] })
        //
        //     window.missingTrans = {
        //         [locale]: {
        //             ...window.missingTrans[locale],
        //             [key]: spaLocaleTranslations[key]
        //         }
        //     }
        // }
    });


    Vue.prototype.$translation = {
        instance: () => i18n,
        t: (key, params = {}) => {
            let translated = i18n.t(key, {...globalVariables, ...params});
            const matches = translated.match(/{(.+)}/gim);

            if (matches) {
                matches.forEach((param) => {
                    translated = translated?.replace(
                        param,
                        params[param?.replace("{", "")?.replace("}", "")] || ""
                    );
                });
            }

            return translated;
        },
        tl: (key, locale, params = {}) => {
            let translated = i18n.t(key, locale, {...globalVariables, ...params});
            const matches = translated.match(/{(.+)}/gim);

            if (matches) {
                matches.forEach((param) => {
                    translated = translated?.replace(
                        param,
                        params[param?.replace("{", "")?.replace("}", "")] || ""
                    );
                });
            }

            return translated;
        },
        tc: (...args) => i18n.tc(...args),
        locale: () => i18n.locale,
        setLocale: (newLocale = "en") => (i18n.locale = newLocale),
    };
}

export default i18nBuilder;
